import { url } from '@ux/header-util';
import { useRootProps } from '../components/UserDataProvider';
import { useState, useEffect } from 'react';

export default function useGetSsoLinks() {
  const { urls } = useRootProps();
  const [ssoLinks, setSsoLinks] = useState({
    createAccountLink: urls?.sso?.createAccount?.href,
    loginLink: urls?.sso?.login?.href,
    logoutLink: urls?.sso?.logout?.href
  });


  const updateLinks = () => {
    let loginLink = ssoLinks.loginLink;
    let logoutLink = ssoLinks.logoutLink;
    let createAccountLink = ssoLinks.createAccountLink;
    const path = window?.location?.pathname ?? '/';
    loginLink = url.updateQuery(loginLink, {
      path
    });
    logoutLink = url.updateQuery(logoutLink, {
      path
    });
    createAccountLink = url.updateQuery(createAccountLink, {
      path
    });

    setSsoLinks({
      createAccountLink,
      loginLink,
      logoutLink
    });
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {

      // Listen for browser navigation events (popstate) and custom history change events (sharedHeader:historyChanged).
      // This ensures that SSO links are updated whenever the user navigates or the app programmatically changes the URL.
      // Without these listeners, the links would not reflect the current path after navigation or history changes,
      // which could lead to incorrect redirects or authentication flows.
      window.addEventListener('popstate', updateLinks);
      window.addEventListener('sharedHeader:historyChanged', updateLinks);

      return () => {
        window.removeEventListener('popstate', updateLinks);
        window.removeEventListener('sharedHeader:historyChanged', updateLinks);
      };
    }
    updateLinks();
  }, []);

  return ssoLinks;
}
